/**
 * Price-map "on stock" band — occurrence-based only (`!is_sold`).
 * Treats `is_sold: null` as on-stock. Live `just_sold` must not influence this band
 * (it does not encode sold duration and would desync dots from backend band counts).
 */
export function isOnStock(car: {is_sold: boolean | null}) {
  return !car.is_sold;
}
